export default __webpack_public_path__ + "static/media/vcard.260fe53f.png";